
import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/logo1.png";
import "./Header.css";


const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className={`header ${menuOpen ? "header--open" : ""}`}>
      <nav className="navbar container">
        <Link to="/" className="logo">
          <img src={logo} alt="Larch Technologies" />
        </Link>

        <ul className="nav-links">
          {/* Services */}
          <li className="nav-item">
            <a href="#services">Services ▾</a>
            <div className="mega-menu">
              <ul>
                <li>
                   <Link to="/LarchErp" className="hover:text-teal-600">
                  Enterprise Applications (ERP)
                  </Link>
                </li>
                <li>
                  <Link to="/IOT" className="hover:text-teal-600">
                   Industrial IoT (IIoT)
                  </Link>
                </li>
                <li>
                   <Link to="/AI_ML" className="hover:text-teal-600">
                   AI/ML
                  </Link>
                </li>
                <li>
                  <Link to="/BigDataAnalytics" className="hover:text-teal-600">
                   Big Data Analytics
                  </Link>
                </li>
                <li>
                  <Link to="/Mobility" className="hover:text-teal-600">
                  Mobility
                  </Link>
                </li>
               <li
                  onClick={() => {
                    const target = document.getElementById("cloud-erp");
                    if (target) {
                      target.scrollIntoView({ behavior: "smooth", block: "start" });
                    }
                  }}
                  className="nav-link"
                  style={{ cursor: "pointer" }}
                >
                  Cloud Services
                </li>

                <li>Digital Services</li>
              </ul>
            </div>
          </li>

          {/* Products */}
          <li className="nav-item">
            <a href="#products">Products ▾</a>
            <div className="mega-menu">
              <ul>
                <li>
                  <Link to="/LarchErp" className="hover:text-teal-600">
                    LarchERP
                  </Link>
                </li>
                <li>LarchVMS</li>
                <li>LarchHRMS</li>
                <li>
                  <Link to="/LarchMes" className="hover:text-teal-600">
                    LarchMES
                  </Link>
                </li>
              </ul>
            </div>
          </li>

          {/* Industries */}
          <li className="nav-item">
            <a href="#industries">Industries ▾</a>
            <div className="mega-menu">
              <ul>
                <li>
                 <Link to="/Automotive" className="hover:text-teal-600">
                    Automotive
                  </Link>
                </li>
                <li>
                   <Link to="/Manufacturing" className="hover:text-teal-600">
                    Manufacturing
                  </Link>
                </li>
                <li>
                   <Link to="/Logistics" className="hover:text-teal-600">
                    Logistics
                  </Link>
                </li>
              </ul>
            </div>
          </li>

          {/* Company */}
          <li className="nav-item">
            <a href="#company">Company ▾</a>
            <div className="mega-menu">
              <ul>
                <li>
                  <Link to="/about" className="hover:text-teal-600">
                    About Us
                  </Link>
                </li>
                <li>Leadership</li>
                 {/* <li><Link to="/SucessStory" className="hover:text-teal-600">
                    Success Story
                  </Link></li> */}

              </ul>
            </div>
          </li>

          <li className="nav-item">
  <Link to="/careers">Careers</Link>
</li>
          <li className="nav-item">
             <Link to="/Contactus">Contact Us</Link>
            </li>
        </ul>

        {/* Hamburger */}
        <button
          className="hamburger"
          aria-label="Toggle menu"
          onClick={() => setMenuOpen((v) => !v)}
        >
          <i className="fas fa-bars" />
        </button>
      </nav>

      {/* Mobile Drawer */}
      {menuOpen && (
        <div className="mobile-drawer container">
          <a onClick={() => setMenuOpen(false)} href="#mes-system">Manufacturing</a>
          <a onClick={() => setMenuOpen(false)} href="#manufacturing-traceability">Traceability</a>
          <a onClick={() => setMenuOpen(false)} href="#home">MES</a>
          <a onClick={() => setMenuOpen(false)} href="#home">QInspection</a>
          <a onClick={() => setMenuOpen(false)} href="#home">Mould</a>
          <a onClick={() => setMenuOpen(false)} href="#home">ProdMonitoring</a>
          <a onClick={() => setMenuOpen(false)} href="#home">IoT</a>
          <a onClick={() => setMenuOpen(false)} href="#home">AI Automation</a>
          <a onClick={() => setMenuOpen(false)} href="#cloud-erp">Cloud ERP</a>
        </div>
      )}
    </header>
  );
};

export default Header;
